window.$ = window.jQuery = require('jquery');



require("jquery-mousewheel");
require('malihu-custom-scrollbar-plugin');


self.debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate)
                func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func.apply(context, args);
    };
}

window.formatDentistInvoiceField = function (value, row) {
    if(value == null) {
        return "-";
    }
    return "<a target='_blank' href='/dentist/invoices/download/" + value + "'>" + value +"</a>";
}

window.formatDentistCommentField = function (value, row) {
    if(value == null) {
        return "-";
    }
    
    var newValue = $.trim(value).substring(0, 15);
    
    if(value.length > 15) {
        return '<span title="' + value  +'">' + newValue + '...</span>';
    }
    
    return '<span title="' + value  +'">' + newValue + '</span>';
}

function DentistInvoiceTable(el) {
    this.el = el;
    this.documentsData = '';
    this.dentistInvoiceTable = this.el.find('.custom-order-table');
    this.dataType = this.el.attr('data-type');
    this.divToPrint = $('#divIdToPrint');
    this.el.find('.columns .dropdown-menu').prepend('<span class="show-cols">Columns to be shown</span>');

//    this.el.find(".scroll-holder").mCustomScrollbar({
//        advanced: {autoExpandHorizontalScroll: false, updateOnContentResize: true},
//    });


    setTimeout(() => {
        this.customTable(this);
        this.bindEvents();
        this.customSearch();
    }, 0);
}

DentistInvoiceTable.prototype = {
    customSearch: function () {
        var $search = $('.fixed-table-toolbar .search input');
        $search.attr('placeholder', 'Søk i ordre');
    },
    reBuildTable: function () {
        var obj = this;
        var actions = function () {
            return obj.el.find("tbody").mCustomScrollbar('destroy');
        };
        var tbUpdate = debounce(obj.customTable, 1);
        //$.when(actions()).done(function () {
            tbUpdate(obj);
        //});
    },
    customTable: function (obj) {

        var tableWidth = $(obj.dentistInvoiceTable).innerWidth(),
            thead = $(obj.dentistInvoiceTable).find('thead'),
            tableHeadTH = $(obj.dentistInvoiceTable).find('thead').find('th'),
            tableBodyTD = $(obj.dentistInvoiceTable).find('tbody').find('tr:first-child td'),
            array = [],
            setTbodyHeight = (obj.el.closest('.full-width').height() - obj.el.siblings('.table-toolbar').outerHeight() - obj.el.find('.fixed-table-container').height()),
            action = function () {
                return  tableHeadTH.each(function (index, el) {
                    array.push(el.clientWidth);
                });
            };

        //obj.el.find('.order-table-wrapper').find('tbody').css({'max-height': setTbodyHeight});

        // promise function
        /*$.when(action()).done(function () {
            obj.el.find("tbody").mCustomScrollbar({
                snapAmount: 50,
                advanced: {autoExpandHorizontalScroll: false, updateOnContentResize: true},
                axis: "y",
                keyboard: {
                    enable: false,
                },
            });
            obj.el.find(".dropdown-menu").mCustomScrollbar();
            // tableBodyTD.each(function(index, el) {
            // 	$(el).css('width', array[index]);		
            // });
            // tableHeadTH.each(function(index, el) {
            // 	$(el).css('width', array[index]);		
            // });
        });*/


    },
    bindEvents: function () {
        var obj = this;
        var activeRow = '';
        var checkedRows = [];

        function selectRow(e) {
            e.stopPropagation();
            selectRowDebFn(e);
        }

        var selectRowDebFn = debounce(function (e) {

            if (e.which != 38 && e.which != 40) {
                return
            }
            if ((!obj.el.closest('.tab-pane').hasClass('show') && obj.previewBox.length)) {
                return;
            }

            switch (e.which) {
                case 38:

                    activeRow = obj.dentistInvoiceTable.find('tr.active');
                    if (activeRow.prev().length) {
                        activeRow.removeClass('active');
                        setTimeout(function () {
                            activeRow.prev().addClass('active');
                        }, 0);
                    }

                    break;
                case 40: // down

                    activeRow = obj.dentistInvoiceTable.find('tr.active');
                    if (activeRow.next().length) {
                        activeRow.removeClass('active');
                        setTimeout(function () {
                            activeRow.next().addClass('active');
                        }, 0);
                    }

                    break;
            }

//            setTimeout(function () {
//                obj.dentistInvoiceTable.find("tbody").mCustomScrollbar("scrollTo", obj.dentistInvoiceTable.find('tbody').find('tr.active'));
//
//            }, 0);
        }, 250);


        $(window).keydown(selectRow);


        obj.dentistInvoiceTable.on('click-row.bs.table', function (row, $element, field) {
            obj.dentistInvoiceTable.find('tbody').find('tr').removeClass('active');
            field.addClass('active');
            //window.location = field.find('.tr-link').attr('href');
        });

        obj.dentistInvoiceTable.on('pre-body.bs.table', function () {

            obj.reBuildTable();
        });

        $('a[href="#' + obj.el.closest('.tab-pane').attr('id') + '"]').on('shown.bs.tab', function (e) {
            obj.reBuildTable();
        });

    }
}
export default DentistInvoiceTable;